var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.98 10.98a.5.5 0 0 1 .707 0l2.667 2.667a.5.5 0 1 1-.707.707l-2.667-2.666a.5.5 0 0 1 0-.708",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.333 2.5a4.833 4.833 0 1 0 0 9.667 4.833 4.833 0 0 0 0-9.667M1.5 7.333a5.833 5.833 0 1 1 11.667 0 5.833 5.833 0 0 1-11.667 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;